import { useQuery } from "@tanstack/react-query";
import { useFeatureFlags } from "swing-components";

import { GET } from "~utils";

import { ExpiringDocument } from "./ExpiringDocumentsBanner";

export function useExpiringDocuments() {
  const FOUR_HOURS_IN_MS = 1000 * 60 * 60 * 4;
  const { flags } = useFeatureFlags();
  const isV2Enabled = flags.expiringDocumentBannerV2;

  return useQuery<any>({
    queryKey: ["fetchExpiringDocuments", isV2Enabled],
    queryFn: () =>
      isV2Enabled
        ? GET("/api/sub/documents/expiring", {
            queryParams: {
              addDetails: true,
              mandatoryOnly: true,
            },
          })
        : GET("/api/sub/documents/expiring"),
    // Cache for 4 hours
    staleTime: FOUR_HOURS_IN_MS,
    // Drop from cache after 4 hours if unused or inactive
    gcTime: FOUR_HOURS_IN_MS,
    select: (data) => {
      if (isV2Enabled) {
        const docs: ExpiringDocument[] = data.data.expiringDocuments;
        const hasMandatory = docs.some((doc) => doc["mandatory?"]);
        return {
          documents: docs,
          shouldBlockSignup: hasMandatory,
          showBanner: docs.length >= 1,
        };
      }

      // For V1, the API returns { expiringDocuments: boolean }
      // which doesn't differentiate mandatory and optional documents
      // Hence if the API returns true, we should show the banner,
      // but not block the request sign-up
      const hasExpiring: boolean = !!data.data.expiringDocuments;
      return {
        documents: [],
        shouldBlockSignup: false,
        showBanner: hasExpiring,
      };
    },
  });
}
